import * as React from 'react';
import { useDeviceType } from '@cian/ui-kit';

import ClientAddForm from '../../components/client_add_form/client_add_form_async';
import { BreadCrumbs } from '../bread_crumbs/bread_crumbs';
import { useAddQuestionPage } from './useAddQuestionPage';
import clientAddFormStyles from '../../components/client_add_form/client_add_form.css';
import s from './add_question.css';

const CONTENT_LIMIT = 5000;

export const AddQuestion: React.FC = () => {
  const deviceType = useDeviceType();
  const {
    user,
    regions,
    tags,
    addQuestion,
    editingItem,
    getCategories,
    onSubmitAdd,
    onSubmitEdit,
    onUploadImage,
  } = useAddQuestionPage();

  return (
    <div className={s['add-question__wrapper']}>
      <div className={s['breadcrumbs-wrap']}>
        <BreadCrumbs />
      </div>
      <ClientAddForm
        user={user}
        item={addQuestion.item}
        heading="задать вопрос"
        entityName="вопроса"
        styles={clientAddFormStyles}
        showLawBlock={false}
        showDescribeBlock={false}
        showImage={false}
        showSubscribe={true}
        tags={tags.items.map(tag => tag.attributes.name)}
        onSubmitAddForm={onSubmitAdd}
        regions={regions.items}
        error={addQuestion.error}
        fetching={addQuestion.fetching}
        categories={getCategories()}
        contentLimit={CONTENT_LIMIT}
        editingItem={editingItem}
        isEdit={addQuestion.isEdit}
        onSubmitEditForm={onSubmitEdit}
        type="question"
        deviceType={deviceType}
        uploadImage={onUploadImage}
      />
      <div className={s['breadcrumbs-wrap-mobile']}>
        <BreadCrumbs mobile={true} />
      </div>
    </div>
  );
};
